export default __webpack_public_path__ + "static/logo-8cf97650bbc2fdc2843d44d1fd6509d8.svg";